export default __webpack_public_path__ + "static/media/Erminia.a799bfab.png";